import { useEffect, useState } from 'react';

export const useDelayedUnmount = (defaultVisibilityValue: boolean, delay: number) => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    if (defaultVisibilityValue) {
      setIsVisible(true);
    } else {
      setTimeout(() => {
        setIsVisible(false);
      }, delay);
    }
  }, [defaultVisibilityValue, delay]);

  return defaultVisibilityValue || isVisible;
};
